// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"400ab34a","422":"385e1702","667":"b91a3faa"}[chunkId] + ".chunk.js";
};